module.exports = __webpack_public_path__ + "assets/check-icon.8682508f.svg";